module.exports = __webpack_public_path__ + "static/media/checkoutbg_left_active.6470d3f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-navbar/progress-bullet/checkoutbg_left_active.svg
// module id = 696
// module chunks = 0